import React from 'react';
import { 
	func, 
} from 'prop-types';
import { withCookies } from 'react-cookie';


class Container extends React.Component {
	static propTypes = {
		render : func.isRequired
	}

	constructor(props) {
		super(props);
		this.state = {
			showSignUp : false,
		};
	}
	
	render(){
		const {render,...other} = this.props;
		
		return render({
			showSignUp : this.state.showSignUp,
			onCLickSignup : (show)=>()=>{
				this.setState({
					showSignUp : show
				});
			}
		},
		other);
	}
}

export default withCookies(Container);
